import React from 'react';

import MyVideos from '../../components/MyVideos/MyVideos';

import styles from './MyVideosPage.module.scss';

const MyVideosPage = () => {
  return (
    <div className={styles.container}>
      <MyVideos />
    </div>
  );
};

export default MyVideosPage;
